module.exports = __webpack_public_path__ + "img/128.5.22f251ca.png";